import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { chipColors } from '../../lib/contrast';

type PurseMovType = 'DEPOSIT' | 'REFUND' | 'RENT' | 'PAYMENT' | 'BUY';

type Props = {
    type: PurseMovType;
};

/**
 * Chip purse movs
 */
export function SttChipPurseMov({ type }: Props): React.ReactElement {
    const { t } = useTranslation();

    const color: Record<PurseMovType, string> = {
        DEPOSIT: '#3186a7',
        REFUND: '#a341bb',
        RENT: '#f35b77',
        PAYMENT: '#d8af54',
        BUY: '#75bb41',
    };

    return (
        <>
            {type && (
                <Chip
                    size="small"
                    label={t(`purseMovTypes.${type.toLowerCase()}`)}
                    style={{ ...chipColors(color[type]) }}
                />
            )}
        </>
    );
}
